import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from 'element-ui';
import { mapActions } from 'vuex';
import addgmAuthority from './components/addgmAuthority';
export default {
  name: "gmAuthorityYJ",
  components: {
    addgmAuthority: addgmAuthority
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      current_page: 1,
      searchData: {
        page: 1,
        page_size: 10,
        user_name: ''
      }
    };
  },
  activated: function activated() {
    this.getData(this.searchData.page);
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/user', ['usersList'])), {}, {
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.page = e;
                _context.next = 3;
                return _this.usersList(_this.searchData);

              case 3:
                query = _context.sent;
                _this.tableData = query.data;
                _this.total = query.total;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    handleDisable: function handleDisable(id) {
      var _this2 = this;

      this.disableRole({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: 'success'
          });

          _this2.getData(_this2.searchData.page);
        }
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.delRole({
                  id: id
                });

              case 2:
                _this3.getData(_this3.searchData.page);

                _this3.$message({
                  type: 'success',
                  message: '删除成功!'
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  })
};